export default __webpack_public_path__ + "static/media/doc-edit.991454a2.svg";